import { render, staticRenderFns } from "./DragCardCargos.vue?vue&type=template&id=19173baa&scoped=true"
import script from "./DragCardCargos.vue?vue&type=script&lang=js"
export * from "./DragCardCargos.vue?vue&type=script&lang=js"
import style0 from "./DragCardCargos.vue?vue&type=style&index=0&id=19173baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19173baa",
  null
  
)

export default component.exports